/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState } from 'react'
import { Image,
Text,
TouchableOpacity,
View,
SafeAreaView} from 'react-native';
import styles from './styles';
import {
Firestore,
getAuth,
signInWithEmailAndPassword } from '../../firebase/config';
import { Input } from 'react-native-elements';
import { KeyboardAwareScrollViewWithDismiss, EmailVerificationPrompt } from '../../components';

export default function LoginScreen({navigation}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [secureText, setSecureText] = useState(true);
    const [secureIcon, setSecureIcon] = useState('eye-off');
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');
    const [emailUnverified, setEmailUnverified] = useState(false);
    const auth = getAuth();

    const onFooterLinkPress = () => {
        navigation.navigate('Registration')
    }

    const forgotPassword = () => {
    navigation.navigate('Forgot Password')
    }


//Toggles secure text fields
const toggleSecureText = () => {
setSecureText(!secureText);
setSecureIcon(
secureIcon === "eye-off"
? "eye"
: "eye-off"
);
}


    const onLoginPress = () => {
    setEmailErrorMessage(null);
    setPasswordErrorMessage(null);
    if (!email) {
    setEmailErrorMessage("Please enter a valid email address");
    return;
    }
    if (!password) {
    setPasswordErrorMessage("Enter Password");
    return;
    }
          signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                const uid = userCredential.user.uid
                const usersRef = Firestore.collection('users')
                usersRef
                    .doc(uid)
                    .get()
                    .then(doc => {
                        if (!doc.exists) {
                            setEmailErrorMessage("User Profile Not Found, If Issue Persists, Please Contact Support.");
                            setPasswordErrorMessage(null);
                            return;
                        }
                        const user = doc.data();
                        user.id = doc.id
                        return navigation;
                    })
                    .catch(error => {
                    console.error("Error creating new user: ", error);
                    });
            })
            .catch(error => {
            console.error("Error authenticating user: ", error);
                switch (error.code) {
                case "auth/user-not-found":
                setEmailErrorMessage("Email Address Not Found");
                setPasswordErrorMessage(null);
                break;
                case "auth/wrong-password":
                setEmailErrorMessage("Invalid Email or Password");
                setPasswordErrorMessage("Invalid Email or Password");
                break;
                case "auth/invalid-email":
                setEmailErrorMessage("Invalid Email or Password");
                setPasswordErrorMessage(null);
                break;
                default:
                setEmailErrorMessage(error.code + " | If Issue Persists, Please Contact Support.");
                setPasswordErrorMessage(error.code + " | If Issue Persists, Please Contact Support.");
                }
            });
    }

    return (
        <SafeAreaView style={styles.container}>
        <KeyboardAwareScrollViewWithDismiss>
         <View style={styles.containerWeb}>
        <Image
        style={styles.logo}
        source={require('../../../assets/empireLogoTransparent.png')}
        />
        <Text style={styles.appSubtitle}>Exclusive Distributor of Hearth & Outdoor Products</Text>
        <Image
         style={styles.welcomeImage}
         source={require('../../../assets/ImageSlider001.jpeg')}
         />
              <Text style={styles.appMessage}>Sign In</Text>
                  <Input
                   placeholder="Email Address"
                   errorMessage={emailErrorMessage}
                   leftIcon={{name: 'mail', color: 'black'}}
                   containerStyle={styles.actionInput}
                   onChangeText={(text) => {setEmail(text)}}
                   value={email}
                   inputStyle={styles.inputStyle}
                   inputContainerStyle={styles.inputContainerStyle}
                   autoCapitalize="none"
                   textContentType={'username'}
                   autoComplete={'email'}
                   />
                  <Input
                   containerStyle={styles.actionInput}
                   inputStyle={styles.inputStyle}
                   inputContainerStyle={styles.inputContainerStyle}
                   secureTextEntry={secureText}
                   placeholder="Password"
                   errorMessage={passwordErrorMessage}
                   leftIcon={{name: 'lock', color: 'black'}}
                   rightIcon={{type: 'feather', name: secureIcon, color: 'black', onPress: () => {toggleSecureText();}}}
                   errorStyle={{color: 'red'}}
                   renderErrorMessage={false}
                   onChangeText={(text) => {setPassword(text)}}
                   autoCapitalize="none"
                   textContentType={'password'}
                   autoComplete={'password'} />
                        <TouchableOpacity
                              style={styles.button}
                              onPress={() => onLoginPress()}>
                              <Text style={styles.buttonTitle}>Log in</Text>
                          </TouchableOpacity>
                          <View style={styles.footerView}>
                              <Text style={styles.footerText}>First Time Using The App? <Text onPress={onFooterLinkPress} style={styles.footerLink}>Register Your Account</Text></Text>
                             <Text style={styles.footerTextForgotPW}>Trouble Logging In? <Text onPress={forgotPassword} style={styles.footerLink}>Forgot Password</Text></Text>
                             <Text style={styles.footerTextDisclaimer}>Notice: You must be a current customer with Empire Distributing in order to use this app. If you are interested in becoming a customer <Text style={{color:'white'}} onPress={() => {navigation.navigate('About')}}>contact us.</Text></Text>
                          </View>
                          </View>
                         <EmailVerificationPrompt
                          email={email}
                          overlayVisible={emailUnverified}
                          continueBtnAction={() => {return null}}
                          backBtnAction={() => {setEmailUnverified(false)}}
                          />
                          </KeyboardAwareScrollViewWithDismiss>
        </SafeAreaView>
    )
}
